import { render, staticRenderFns } from "./CultivationStatistics.vue?vue&type=template&id=dcccee2e&scoped=true&"
import script from "./CultivationStatistics.vue?vue&type=script&lang=js&"
export * from "./CultivationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CultivationStatistics.vue?vue&type=style&index=0&id=dcccee2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcccee2e",
  null
  
)

export default component.exports